module.exports = __webpack_public_path__ + "img/US.b8d2fa02.png";